import { Injectable } from '@angular/core';

import { ValidatorBindModel, ControlSpecification } from '../types';
import { OSSClientConfig } from '../services';
import { AssociatedDataEntity } from './specification-helper';

/**
 *  è®¾è®¡å¨éç½®
 *
 * @export
 * @abstract
 */
@Injectable({ providedIn: 'root' })
export abstract class DynamicFormDesignerConfig {
  /**
   *  éé¡¹æ§ä»¶æ°æ®æº
   *
   * @memberof DynamicFormDesignerConfig
   */
  optionDataSource: {
    /**
     *  urlå°åãæ°æ®æºæå¡å°åãå¦æä¸ºç©ºååæ¬å°è·¯å¾
     *
     */
    baseUrl: string;
  };
  /**
   *  æå¡å°å
   *
   * @memberof DynamicFormDesignerConfig
   */
  serviceUrl: string;

  /**
   * çº§èæ ¹æ®urlè·åæ°æ®é²ææ¶é´
   */
  cascadeDataByUrlDebounceDueTime?: number = 50;

  /**
   * é¿éäºOssClientéç½®
   *
   * @memberof DynamicFormDesignerConfig
   */
  abstract getAliOssClientConfig(id: any): OSSClientConfig;
  /**
   *  ç¨æ¥ç»å®éªè¯å¨
   *
   * @abstract
   * @returns ä¸ä¸ªéªè¯å¨ç»å®modelçéå
   * @memberof DynamicFormDesignerConfig
   */
  abstract bindValidator(): Array<ValidatorBindModel>;
  /**
   *  åå§ååï¼ç¨æ¥è®¾ç½®é»è®¤æ§ä»¶ï¼æèç»å®æ°çæ§ä»¶
   *
   * @abstract
   * @param specifications å·²åå§åçæææ§ä»¶è§æ ¼è¯´æ
   * @returns æ°çæ§ä»¶è§æ ¼è¯´æ
   * @memberof DynamicFormDesignerConfig
   */
  abstract afterInit(
    specifications: Array<ControlSpecification>,
    dataEntities: Array<AssociatedDataEntity>
  ): Array<ControlSpecification>;
}
